module.exports = __webpack_public_path__ + "media/images/client/volume_icon-8ae9ba888a527249f2266990f78cdd5f.png";